module.exports = __webpack_public_path__ + "img/error404.e8b635b9.svg";